module.exports = __webpack_public_path__ + "img/mouth-1-1.052fc225.svg";